import { buildUrlWithParams } from './urls';
export function getSafeWindow() {
  if (typeof window !== 'undefined') {
    return window;
  }
  return undefined;
}
export function getUrlParam(key) {
  var _getSafeWindow;
  const params = new URLSearchParams((_getSafeWindow = getSafeWindow()) == null ? void 0 : _getSafeWindow.location.search);
  return params.get(key);
}
export function removeUrlParam(key) {
  const url = new URL(window.location.href);
  url.searchParams.delete(key);
  window.history.replaceState({}, '', url);
}
export function extractUrlParam(key) {
  const param = getUrlParam(key);
  removeUrlParam(key);
  return param;
}
export function matchUrlParam(key, value) {
  return getUrlParam(key) === value;
}
export function isMobileDevice() {
  var _getSafeWindow2;
  const userAgent = ((_getSafeWindow2 = getSafeWindow()) == null ? void 0 : _getSafeWindow2.navigator.userAgent) ?? '';
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}
export function redirectToUrl(baseURL, params) {
  const url = buildUrlWithParams(baseURL, params ?? {});
  window.location.href = url;
}
export function getUrlQueryParams() {
  var _getSafeWindow3;
  return Object.fromEntries(new URLSearchParams((_getSafeWindow3 = getSafeWindow()) == null ? void 0 : _getSafeWindow3.location.search).entries());
}
export function getMobileProvider() {
  switch (true) {
    case /iPhone|iPad|iPod/i.test(navigator.userAgent):
      return 'apple';
    case /Android/i.test(navigator.userAgent):
      return 'google';
    default:
      return null;
  }
}
export function openUrlNewTab(url) {
  var _getSafeWindow4;
  return (_getSafeWindow4 = getSafeWindow()) == null ? void 0 : _getSafeWindow4.open(url, '_blank');
}
//# sourceMappingURL=window.js.map